import { createContext, useContext, useReducer } from 'react'

import {
  TopDownloadBannerContext,
  topDownloadBannerInitialState,
  topDownloadBannerReducer,
} from './state/TopDownloadBanner'

type GlobalStoreContext = TopDownloadBannerContext

const GlobalStoreContext = createContext<GlobalStoreContext>({
  topDownloadBanner: topDownloadBannerInitialState,
  topDownloadBannerDispatch: () => undefined,
})

export function GlobalStateProvider({ children }: { children: React.ReactNode }): JSX.Element {
  // GlobalState는 전역적으로 사용되는 상태를 관리하기 때문에 상태변화에 대한 맥락을 모두 알아야 합니다. 따라서, useState 대신 useReducer를 사용합니다.
  const [topDownloadBanner, topDownloadBannerDispatch] = useReducer(
    topDownloadBannerReducer,
    topDownloadBannerInitialState,
  )

  return (
    <GlobalStoreContext.Provider value={{ topDownloadBanner, topDownloadBannerDispatch }}>
      {children}
    </GlobalStoreContext.Provider>
  )
}

export function useGlobalState(): GlobalStoreContext {
  return useContext(GlobalStoreContext)
}
